<script lang="ts">
  export let title: string;
  export let iconOnly = false;
  let className: string = "";

  function sellerPreferenceIcons(title: string) {
    className = (title || "").replaceAll(" ", "-").toLowerCase();
  }

  $: sellerPreferenceIcons(title);
</script>

<section class="icons grid">
  <i class={className} />
  {#if !iconOnly}
    <p class="pf-300">
      {(title || "").replaceAll("-", " ")}
    </p>
  {/if}
</section>

<style lang="scss">
  .icons {
    font-size: 1em;
    text-transform: capitalize;
    grid-template-columns: 1em auto;
    align-items: center;
    gap: 0;
    p {
      margin: 0;
      margin-left: 1em;
    }
    i {
      line-height: calc(0.8125em + 0.3125em * 2);
      display: block;
      width: 0.5em;
      height: 0.8em;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      &.mobile,
      &.mobile-link,
      &.e-tickets {
        background-image: url(../_assets/mobile.svg);
      }
      &.seated-together {
        width: 1em;
        height: 1em;
        background-image: url(../_assets/together.svg);
      }
      &.single-seats {
        width: 1em;
        height: 1.1em;
        background-image: url(../_assets/single-seat.svg);
      }
      &.paper-tickets {
        width: 1.7em;
        height: 1.1em;
        background-image: url(../_assets/paper.svg);
      }
    }
  }
</style>
